export class CreditLineFNB {
    public isCreditLineFNB: boolean;
    public amount: number;
    public amountFormat: string;
    public firstName: string;
    public FirstNameMask: string;
    public orderPopupFNB: number;
    public orderPopupHome: number;
    public statusPopupFNB: boolean;
    public statusPopupHome: boolean;
}